import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sun, Moon, Globe } from 'lucide-react';
import { motion } from 'framer-motion';
import { useThemeStore } from '../store/themeStore';

interface UserSettingsProps {
  onSettingChange?: () => void;
}

const UserSettings: React.FC<UserSettingsProps> = ({ onSettingChange }) => {
  const { t, i18n } = useTranslation();
  const { isDark, toggleTheme } = useThemeStore();

  const handleThemeToggle = () => {
    toggleTheme();
    onSettingChange?.();
  };

  const handleLanguageToggle = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
    onSettingChange?.();
  };

  return (
    <div className="px-4 pb-2">
      <div className="space-y-2">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleThemeToggle}
          className="w-full flex items-center justify-between px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg"
        >
          <div className="flex items-center">
            {isDark ? (
              <Moon className="w-4 h-4 mr-2 text-blue-600 dark:text-blue-400" />
            ) : (
              <Sun className="w-4 h-4 mr-2 text-yellow-500" />
            )}
            <span>Mode {isDark ? 'sombre' : 'clair'}</span>
          </div>
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleLanguageToggle}
          className="w-full flex items-center justify-between px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg"
        >
          <div className="flex items-center">
            <Globe className="w-4 h-4 mr-2 text-green-600 dark:text-green-400" />
            <span>Langue: {i18n.language.toUpperCase()}</span>
          </div>
        </motion.button>
      </div>
    </div>
  );
};

export default UserSettings;